import { Chart } from "react-charts";
import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

export default function SVMP() {
    const data = React.useMemo(
        () => [
          {
            label: "Precision Training",
            data: [
              { primary: "Action", secondary: 0.700013131},
              { primary: "Adventure", secondary: 0.73801021},
              { primary: "Arcade", secondary: 0.77034123},
              { primary: "Board Games", secondary: 0.8601311},
              { primary: "Card", secondary: 0.927130320},
              { primary: "Casual", secondary: 0.67502320},
              { primary: "Educational", secondary: 0.8852323},
              { primary: "Family", secondary: 0.8151003202},
              { primary: "Fighting", secondary: 0.891002320},
              { primary: "Indie", secondary: 0.720010130},
              { primary: "Multiplayer", secondary: 0.90013013},
              { primary: "Platformer", secondary: 0.77500120012},
              { primary: "Puzzle", secondary: 0.7680023023},
              { primary: "RPG", secondary: 0.78012012},
              { primary: "Racing", secondary: 0.890121238},
              { primary: "Shooter", secondary: 0.799837137},
              { primary: "Simulation", secondary: 0.73820121},
              { primary: "Sports", secondary: 0.825032323},
              { primary: "Strategy", secondary: 0.79831313},
            ],
          }, {
            label: "Precision Testing",
            data: [
              { primary: "Action", secondary: 0.71001313},
              { primary: "Adventure", secondary: 0.737998232},
              { primary: "Arcade", secondary: 0.7410291291},
              { primary: "Board Games", secondary: 0.82023928},
              { primary: "Card", secondary: 0.89998127127},
              { primary: "Casual", secondary: 0.63893727},
              { primary: "Educational", secondary: 0.7750248248},
              { primary: "Family", secondary: 0.839988131},
              { primary: "Fighting", secondary: 0.813040242},
              { primary: "Indie", secondary: 0.700129128},
              { primary: "Multiplayer", secondary: 0.8389127373},
              { primary: "Platformer", secondary: 0.775000291},
              { primary: "Puzzle", secondary: 0.76301313},
              { primary: "RPG", secondary: 0.760023823},
              { primary: "Racing", secondary: 0.895023234},
              { primary: "Shooter", secondary: 0.799987888},
              { primary: "Simulation", secondary: 0.720010130},
              { primary: "Sports", secondary: 0.7999812812},
              { primary: "Strategy", secondary: 0.79831313},
            ],
          }, 
        ],
        []
      );
      const axes = React.useMemo(
        () => [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { type: 'linear', position: 'left' },
        ], []
      );
      return (
          <ReactResizableBox width={500} height={300} style={{textAlign: "center"}}>
              <strong>Precision of SVM</strong>
              <Chart data={data} axes={axes} tooltip/>
          </ReactResizableBox>
      );
};